// ============================================
// MINDPIXELS — About page animations + founder modal
// ============================================

document.addEventListener('DOMContentLoaded', function () {

  // --- Hero fade in ---
  var heroTexts = document.querySelector('.about-hero__texts');
  var heroImage = document.querySelector('.about-hero__image');

  if (heroTexts)  heroTexts.style.cssText  = 'opacity:0;transform:translateY(32px);transition:opacity 0.9s ease,transform 0.9s ease;';
  if (heroImage) heroImage.style.cssText = 'opacity:0;transform:translateX(32px);transition:opacity 0.9s 0.2s ease,transform 0.9s 0.2s ease;';

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      if (heroTexts)  { heroTexts.style.opacity  = '1'; heroTexts.style.transform  = 'translateY(0)'; }
      if (heroImage) { heroImage.style.opacity = '1'; heroImage.style.transform = 'translateX(0)'; }
    });
  });

  // --- Skills cards fade in on scroll ---
  var skillCards = document.querySelectorAll('.about-skills__card');
  if (skillCards.length) {
    var skillObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.style.opacity  = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 120);
          skillObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    skillCards.forEach(function (card) {
      card.style.cssText = 'opacity:0;transform:translateY(40px);transition:opacity 0.7s ease,transform 0.7s ease;';
      skillObs.observe(card);
    });
  }

  // --- Founders: staggered fly-in from bottom on scroll ---
  var founderCards = document.querySelectorAll('.about-founders__card');
  if (founderCards.length) {
    var founderObs = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (e) { return e.isIntersecting; });
      if (!visible) return;
      founderCards.forEach(function (card, i) {
        setTimeout(function () { card.classList.add('is-visible'); }, i * 140);
      });
      founderObs.disconnect();
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    var grid = document.querySelector('.about-founders__grid');
    if (grid) founderObs.observe(grid);
  }

  // --- Founders title fade in ---
  var foundersTitle = document.querySelector('.about-founders__title');
  if (foundersTitle) {
    foundersTitle.style.cssText = 'opacity:0;transform:translateY(24px);transition:opacity 0.8s ease,transform 0.8s ease;';
    var titleObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        foundersTitle.style.opacity   = '1';
        foundersTitle.style.transform = 'translateY(0)';
        titleObs.disconnect();
      }
    }, { threshold: 0.3 });
    titleObs.observe(foundersTitle);
  }

  // ============================================
  // FOUNDER MODAL
  // ============================================
  var modal       = document.getElementById('founderModal');
  var modalBox    = document.getElementById('founderModalBox');
  var modalClose  = document.getElementById('founderModalClose');
  var modalBack   = document.getElementById('founderModalBackdrop');
  var modalName   = document.getElementById('founderModalName');
  var modalRole   = document.getElementById('founderModalRole');
  var modalBio    = document.getElementById('founderModalBio');

  function openFounderModal(card) {
    var name   = card.dataset.founderName  || '';
    var role   = card.dataset.founderRole  || '';
    var bio    = card.dataset.founderBio   || '';
    var accent = card.dataset.founderAccent || 'cyan';

    modalName.textContent = name;
    modalRole.textContent = role;
    modalBio.textContent  = bio;

    modalBox.className = 'founder-modal__box founder-modal__box--' + accent;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFounderModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  founderCards.forEach(function (card) {
    card.addEventListener('click', function () { openFounderModal(card); });
  });

  if (modalClose) modalClose.addEventListener('click', closeFounderModal);
  if (modalBack)  modalBack.addEventListener('click', closeFounderModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFounderModal();
  });

});
